import { memo } from 'react';
import { Box, FelaCSS, ImageX } from '@bridebook/ui';
import componentStyles from './thumbnail.style';

interface ThumbnailProps {
  src: string;
  width?: number;
  height?: number;
  isVenue?: boolean;
  isSSR?: boolean;
  style?: FelaCSS;
}

const ThumbnailComponent = ({ src, width, height, isSSR, style = {} }: ThumbnailProps) => {
  const styles = componentStyles();
  return width && height ? (
    <Box style={Object.assign(styles.wrapper, style)}>
      <ImageX
        src={src}
        w={width}
        h={height}
        style={{ height: '100%' }}
        imageStyle={styles.image}
        isSSR={isSSR}
      />
    </Box>
  ) : null;
};

export const Thumbnail = memo(ThumbnailComponent);
